import { Box, MenuItem, Select } from '@mui/material'
import i18n from '../../../../lang/idiomas'

/**
 * The WebPresupuestosSortBy component
 * @component
 *
 * @param {Object} props
 * @param {string} props.sortBy
 * @param {function} props.handleSortByChange

 * @returns {JSX.Element}
 */

const WebPresupuestosSortBy = ({ sortBy, handleSortByChange }) => {
  return (
    <Box
      component='form'
      noValidate
      autoComplete='off'
      sx={{
        display: 'flex',
        alignItems: 'end',
        gap: '5px',
        flexDirection: 'column',
        mb: '14px',
      }}>
      <Select
        sx={{
          '& div': {
            bgcolor: '#e2e2e2',
            borderRadius: '4px',
            p: '5px 14px',
          },
          '& fieldset': {
            border: 'none',
          },
          width: '30%',
        }}
        labelId='demo-simple-select-label'
        id='demo-simple-select'
        value={sortBy || '-fecha'}
        label={i18n.t('webpresupuestos.wpsblbl')}
        onChange={e => {
          handleSortByChange(e.target.value)
        }}>
        <MenuItem
          key={'id_asc'}
          value={'id_pedido'}>
          {i18n.t('webpresupuestos.wpsbidas')}
        </MenuItem>
        <MenuItem
          key={'id_dec'}
          value={'-id_pedido'}>
          {i18n.t('webpresupuestos.wpsbidds')}
        </MenuItem>
        <MenuItem
          key={'fecha_asc'}
          value={'fecha'}>
          {i18n.t('webpresupuestos.wpsbfcas')}
        </MenuItem>
        <MenuItem
          key={'fecha_desc'}
          value={'-fecha'}>
          {i18n.t('webpresupuestos.wpsbfcds')}
        </MenuItem>
      </Select>
    </Box>
  )
}

export default WebPresupuestosSortBy
